import OwnerRoute from "../common/components/OwnerRoute";
import Financials from "./pages/Financials";
import ProducerDetail from "./pages/ProducerDetail";

const financialRoutes = [
  {
    path: "/financials",
    element: (
      <OwnerRoute>
        <Financials />
      </OwnerRoute>
    ),
  },
  {
    path: "/financials/producer/:userId",
    element: (
      <OwnerRoute>
        <ProducerDetail />
      </OwnerRoute>
    ),
  },
];

export default financialRoutes;
